/** Shopify CDN: Minification failed

Line 13:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 183:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 184:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 185:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 186:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 231:5 Transforming const to the configured target environment ("es5") is not supported yet
Line 233:6 Transforming const to the configured target environment ("es5") is not supported yet

**/
    // javascript code maplocation change
    const buttons = document.querySelectorAll('.variations-grid-button');

      // Get cm/inches properties
      // centimeter properties
      var get_spalla_cm_id = document.getElementById('size-guide-cm-SPALLA');
      var get_LUNGHEZZA_cm_id = document.getElementById('size-guide-cm-LUNGHEZZA');
      var get_TORACE_cm_id = document.getElementById('size-guide-cm-TORACE');
      var get_LUNGHEZZA_DELLE_cm_id = document.getElementById('size-guide-cm-LUNGHEZZA-DELLE');
      var get_LARGHEZZA_FONDO_cm_id = document.getElementById('size-guide-cm-LARGHEZZA-FONDO');
      // new added in cm
      var get_LUNGHEZZA_DELLE_cm_id_1 = document.getElementById('size-guide-cm-LARGHEZZA-FONDO-1');
      var get_LUNGHEZZA_DELLE_cm_id_2 = document.getElementById('size-guide-cm-LARGHEZZA-FONDO-2');
      var get_LUNGHEZZA_DELLE_cm_id_3 = document.getElementById('size-guide-cm-LARGHEZZA-FONDO-3');
      // Inches properties
      var get_spalla_in_id = document.getElementById('size-guide-in-SPALLA');
      var get_LUNGHEZZA_in_id = document.getElementById('size-guide-in-LUNGHEZZA')
      var get_TORACE_in_id = document.getElementById('size-guide-in-TORACE');
      var get_LUNGHEZZA_DELLE_in_id = document.getElementById('size-guide-in-LUNGHEZZA-DELLE');
      var get_LARGHEZZA_FONDO_in_id = document.getElementById('size-guide-in-LARGHEZZA-FONDO');
      // new added in inches
      var get_LUNGHEZZA_DELLE_in_id_1 = document.getElementById('size-guide-in-LARGHEZZA-FONDO-1');
      var get_LUNGHEZZA_DELLE_in_id_2 = document.getElementById('size-guide-in-LARGHEZZA-FONDO-2');
      var get_LUNGHEZZA_DELLE_in_id_3 = document.getElementById('size-guide-in-LARGHEZZA-FONDO-3');

      var get_size_a_s = $('#odd_cell_a_s').text()
      var get_size_a_m = $('#odd_cell_a_m').text()
      var get_size_a_l = $('#odd_cell_a_l').text()
      var get_size_a_xl = $('#odd_cell_a_xl').text()
      //
      var get_size_b_s = $('#odd_cell_b_s').text()
      var get_size_b_m = $('#odd_cell_b_m').text()
      var get_size_b_l = $('#odd_cell_b_l').text()
      var get_size_b_xl = $('#odd_cell_b_xl').text()
      //
      var get_size_c_s = $('#odd_cell_c_s').text()
      var get_size_c_m = $('#odd_cell_c_m').text()
      var get_size_c_l = $('#odd_cell_c_l').text()
      var get_size_c_xl = $('#odd_cell_c_xl').text()
      //
      var get_size_d_s = $('#odd_cell_d_s').text()
      var get_size_d_m = $('#odd_cell_d_m').text()
      var get_size_d_l = $('#odd_cell_d_l').text()
      var get_size_d_xl = $('#odd_cell_d_xl').text()
      //
      var get_size_e_s = $('#odd_cell_e_s').text()
      var get_size_e_m = $('#odd_cell_e_m').text()
      var get_size_e_l = $('#odd_cell_e_l').text()
      var get_size_e_xl = $('#odd_cell_e_xl').text()
      //
      var get_size_f_s = $('#odd_cell_f_s').text()
      var get_size_f_m = $('#odd_cell_f_m').text()
      var get_size_f_l = $('#odd_cell_f_l').text()
      var get_size_f_xl = $('#odd_cell_f_xl').text()
      //
      var get_size_g_s = $('#odd_cell_g_s').text()
      var get_size_g_m = $('#odd_cell_g_m').text()
      var get_size_g_l = $('#odd_cell_g_l').text()
      var get_size_g_xl = $('#odd_cell_g_xl').text()
      //
      var get_size_h_s = $('#odd_cell_h_s').text()
      var get_size_h_m = $('#odd_cell_h_m').text()
      var get_size_h_l = $('#odd_cell_h_l').text()
      var get_size_h_xl = $('#odd_cell_h_xl').text()

      // get all the inches
      var in_get_size_a_s = $('#in_odd_cell_a_s').text()
      var in_get_size_a_m = $('#in_odd_cell_a_m').text()
      var in_get_size_a_l = $('#in_odd_cell_a_l').text()
      var in_get_size_a_xl = $('#in_odd_cell_a_xl').text()
      //
      var in_get_size_b_s = $('#in_odd_cell_b_s').text()
      var in_get_size_b_m = $('#in_odd_cell_b_m').text()
      var in_get_size_b_l = $('#in_odd_cell_b_l').text()
      var in_get_size_b_xl = $('#in_odd_cell_b_xl').text()
      //
      var in_get_size_c_s = $('#in_odd_cell_c_s').text()
      var in_get_size_c_m = $('#in_odd_cell_c_m').text()
      var in_get_size_c_l = $('#in_odd_cell_c_l').text()
      var in_get_size_c_xl = $('#in_odd_cell_c_xl').text()
      //
      var in_get_size_d_s = $('#in_odd_cell_d_s').text()
      var in_get_size_d_m = $('#in_odd_cell_d_m').text()
      var in_get_size_d_l = $('#in_odd_cell_d_l').text()
      var in_get_size_d_xl = $('#in_odd_cell_d_xl').text()
      //
      var in_get_size_e_s = $('#in_odd_cell_e_s').text()
      var in_get_size_e_m = $('#in_odd_cell_e_m').text()
      var in_get_size_e_l = $('#in_odd_cell_e_l').text()
      var in_get_size_e_xl = $('#in_odd_cell_e_xl').text()
      //
      var in_get_size_f_s = $('#in_odd_cell_f_s').text()
      var in_get_size_f_m = $('#in_odd_cell_f_m').text()
      var in_get_size_f_l = $('#in_odd_cell_f_l').text()
      var in_get_size_f_xl = $('#in_odd_cell_f_xl').text()
      //
      var in_get_size_g_s = $('#in_odd_cell_g_s').text()
      var in_get_size_g_m = $('#in_odd_cell_g_m').text()
      var in_get_size_g_l = $('#in_odd_cell_g_l').text()
      var in_get_size_g_xl = $('#in_odd_cell_g_xl').text()
      //
      var in_get_size_h_s = $('#in_odd_cell_h_s').text()
      var in_get_size_h_m = $('#in_odd_cell_h_m').text()
      var in_get_size_h_l = $('#in_odd_cell_h_l').text()
      var in_get_size_h_xl = $('#in_odd_cell_h_xl').text()

      buttons.forEach(button => {
          button.addEventListener('click', () => {
              buttons.forEach(btn => {
                  btn.setAttribute('aria-pressed', 'false');
                  btn.classList.remove('active');
              });
              button.setAttribute('aria-pressed', 'true');
              button.classList.add('active');

              // if (button.textContent.trim() === 'XXS') {
              //     get_spalla_in_id.textContent = '20 Inches';
              //     get_LUNGHEZZA_in_id.textContent = '24 Inches';
              //     get_TORACE_in_id.textContent = '24 Inches';
              //     get_LUNGHEZZA_DELLE_in_id.textContent = '33 Inches';
              //     get_LARGHEZZA_FONDO_in_id.textContent = '15 Inches';

              //     get_spalla_cm_id.textContent = '52 CM';
              //     get_LUNGHEZZA_cm_id.textContent = '60 CM';
              //     get_TORACE_cm_id.textContent = '60 CM';
              //     get_LUNGHEZZA_DELLE_cm_id.textContent = '85 CM';
              //     get_LARGHEZZA_FONDO_cm_id.textContent = '40 CM';

              // }if (button.textContent.trim() === 'XS') {
              //     get_spalla_in_id.textContent = '22 Inches';
              //     get_LUNGHEZZA_in_id.textContent = '26 Inches';
              //     get_TORACE_in_id.textContent = '26 Inches';
              //     get_LUNGHEZZA_DELLE_in_id.textContent = '35 Inches';
              //     get_LARGHEZZA_FONDO_in_id.textContent = '17 Inches';

              //     get_spalla_cm_id.textContent = '56 CM';
              //     get_LUNGHEZZA_cm_id.textContent = '68 CM';
              //     get_TORACE_cm_id.textContent = '68 CM';
              //     get_LUNGHEZZA_DELLE_cm_id.textContent = '95 CM';
              //     get_LARGHEZZA_FONDO_cm_id.textContent = '45 CM';

              // }
              if (button.textContent.trim() === 'S') {
                  get_spalla_in_id.textContent = in_get_size_c_s+' IN';
                  get_LUNGHEZZA_in_id.textContent = in_get_size_b_s+' IN';
                  get_TORACE_in_id.textContent = in_get_size_d_s+' IN';
                  get_LUNGHEZZA_DELLE_in_id.textContent = in_get_size_a_s+' IN';
                  get_LARGHEZZA_FONDO_in_id.textContent = in_get_size_e_s+' IN';
                  // new added
                  get_LUNGHEZZA_DELLE_in_id_1.textContent = get_size_f_s+' IN';
                  get_LUNGHEZZA_DELLE_in_id_2.textContent = get_size_g_s+' IN';
                  get_LUNGHEZZA_DELLE_in_id_3.textContent = get_size_h_s+' IN';

                  get_spalla_cm_id.textContent = get_size_c_s+' CM';
                  get_LUNGHEZZA_cm_id.textContent = get_size_b_s+' CM';
                  get_TORACE_cm_id.textContent = get_size_d_s+' CM';
                  get_LUNGHEZZA_DELLE_cm_id.textContent = get_size_a_s+' CM';
                  get_LARGHEZZA_FONDO_cm_id.textContent = get_size_e_s+' CM';
                  // new added
                  get_LUNGHEZZA_DELLE_cm_id_1.textContent = get_size_f_s+' CM';
                  get_LUNGHEZZA_DELLE_cm_id_2.textContent = get_size_g_s+' CM';
                  get_LUNGHEZZA_DELLE_cm_id_3.textContent = get_size_h_s+' CM';

              }if (button.textContent.trim() === 'M') {
                  get_spalla_in_id.textContent = in_get_size_c_m+' IN';
                  get_LUNGHEZZA_in_id.textContent = in_get_size_b_m+' IN';
                  get_TORACE_in_id.textContent = in_get_size_d_m+' IN';
                  get_LUNGHEZZA_DELLE_in_id.textContent = in_get_size_a_m+' IN';
                  get_LARGHEZZA_FONDO_in_id.textContent = in_get_size_e_m+' IN';
                  // new added
                  get_LUNGHEZZA_DELLE_in_id_1.textContent = get_size_f_s+' IN';
                  get_LUNGHEZZA_DELLE_in_id_2.textContent = get_size_g_s+' IN';
                  get_LUNGHEZZA_DELLE_in_id_3.textContent = get_size_h_s+' IN';

                  get_spalla_cm_id.textContent = get_size_c_m+' CM';
                  get_LUNGHEZZA_cm_id.textContent = get_size_b_m+' CM';
                  get_TORACE_cm_id.textContent = get_size_d_m+' CM';
                  get_LUNGHEZZA_DELLE_cm_id.textContent = get_size_a_m+' CM';
                  get_LARGHEZZA_FONDO_cm_id.textContent = get_size_e_m+' CM';
                  // new added
                  get_LUNGHEZZA_DELLE_cm_id_1.textContent = get_size_f_s+' CM';
                  get_LUNGHEZZA_DELLE_cm_id_2.textContent = get_size_g_s+' CM';
                  get_LUNGHEZZA_DELLE_cm_id_3.textContent = get_size_h_s+' CM';

              }if (button.textContent.trim() === 'L') {
                  get_spalla_in_id.textContent = in_get_size_c_l+' IN';
                  get_LUNGHEZZA_in_id.textContent = in_get_size_b_l+' IN';
                  get_TORACE_in_id.textContent = in_get_size_d_l+' IN';
                  get_LUNGHEZZA_DELLE_in_id.textContent = in_get_size_a_l+' IN';
                  get_LARGHEZZA_FONDO_in_id.textContent = in_get_size_e_l+' IN';
                  // new added
                  get_LUNGHEZZA_DELLE_in_id_1.textContent = get_size_f_s+' IN';
                  get_LUNGHEZZA_DELLE_in_id_2.textContent = get_size_g_s+' IN';
                  get_LUNGHEZZA_DELLE_in_id_3.textContent = get_size_h_s+' IN';

                  get_spalla_cm_id.textContent = get_size_c_l+' CM';
                  get_LUNGHEZZA_cm_id.textContent = get_size_b_l+' CM';
                  get_TORACE_cm_id.textContent = get_size_d_l+' CM';
                  get_LUNGHEZZA_DELLE_cm_id.textContent = get_size_a_l+' CM';
                  get_LARGHEZZA_FONDO_cm_id.textContent = get_size_e_l+' CM';
                  // new added
                  get_LUNGHEZZA_DELLE_cm_id_1.textContent = get_size_f_s+' CM';
                  get_LUNGHEZZA_DELLE_cm_id_2.textContent = get_size_g_s+' CM';
                  get_LUNGHEZZA_DELLE_cm_id_3.textContent = get_size_h_s+' CM';

              }if (button.textContent.trim() === 'XL') {
                  get_spalla_in_id.textContent = in_get_size_c_xl+' IN';
                  get_LUNGHEZZA_in_id.textContent = in_get_size_b_xl+' IN';
                  get_TORACE_in_id.textContent = in_get_size_d_xl+' IN';
                  get_LUNGHEZZA_DELLE_in_id.textContent = in_get_size_a_xl+' IN';
                  get_LARGHEZZA_FONDO_in_id.textContent = in_get_size_e_xl+' IN';
                  // new added
                  get_LUNGHEZZA_DELLE_in_id_1.textContent = get_size_f_s+' IN';
                  get_LUNGHEZZA_DELLE_in_id_2.textContent = get_size_g_s+' IN';
                  get_LUNGHEZZA_DELLE_in_id_3.textContent = get_size_h_s+' IN';

                  get_spalla_cm_id.textContent = get_size_c_xl+' CM';
                  get_LUNGHEZZA_cm_id.textContent = get_size_b_xl+' CM';
                  get_TORACE_cm_id.textContent = get_size_d_xl+' CM';
                  get_LUNGHEZZA_DELLE_cm_id.textContent = get_size_a_xl+' CM';
                  get_LARGHEZZA_FONDO_cm_id.textContent = get_size_e_xl+' CM';
                  // new added
                  get_LUNGHEZZA_DELLE_cm_id_1.textContent = get_size_f_s+' CM';
                  get_LUNGHEZZA_DELLE_cm_id_2.textContent = get_size_g_s+' CM';
                  get_LUNGHEZZA_DELLE_cm_id_3.textContent = get_size_h_s+' CM';
              }
              // if (button.textContent.trim() === 'XXL') {
              //     get_spalla_in_id.textContent = '32 Inches';
              //     get_LUNGHEZZA_in_id.textContent = '34 Inches';
              //     get_TORACE_in_id.textContent = '34 Inches';
              //     get_LUNGHEZZA_DELLE_in_id.textContent = '43 Inches';
              //     get_LARGHEZZA_FONDO_in_id.textContent = '25 Inches';

              //     get_spalla_cm_id.textContent = '84 CM';
              //     get_LUNGHEZZA_cm_id.textContent = '90 CM';
              //     get_TORACE_cm_id.textContent = '90 CM';
              //     get_LUNGHEZZA_DELLE_cm_id.textContent = '112 CM';
              //     get_LARGHEZZA_FONDO_cm_id.textContent = '66 CM';
              // }
          });
      });
      const cmRadio = document.getElementById("CM");
      const inchRadio = document.getElementById("inch");
      const cmMeasurements = document.querySelectorAll('[data-content-cm-id="sizeguide-measurement-cm"]');
      const inchMeasurements = document.querySelectorAll('[data-content-inches-id="sizeguide-measurement-inches"]');
      function showInchMeasurements() {
        cmMeasurements.forEach(cm => cm.classList.add("hide"));
        inchMeasurements.forEach(inch => inch.classList.remove("hide"));
      }
      function showCmMeasurements() {
        inchMeasurements.forEach(inch => inch.classList.add("hide"));
        cmMeasurements.forEach(cm => cm.classList.remove("hide"));
      }
      if (cmRadio.checked) {
        showCmMeasurements();
      } else if (inchRadio.checked) {
        showInchMeasurements();
      }
      cmRadio.addEventListener("change", showCmMeasurements);
      inchRadio.addEventListener("change", showInchMeasurements);

    // jquery inches to cm converter

   $(document).on("click", "button.variations-grid-button", function(event) {
    event.preventDefault();  
    jQuery('.radio-group-label[data-for="CM"]').click();
    jQuery("table.custom-table").find("td").removeClass("active");
     $(".sizeguide-select-info").hide();
     $("button.variations-grid-button").removeClass("active")
     $(this).addClass("active")
     var data_size = $(this).attr("data-value");
     if(data_size == 's'){
        jQuery("table.custom-table").find("td:nth-child(2)").addClass("active");
     }
      if(data_size == 'm'){
       jQuery("table.custom-table").find("td:nth-child(3)").addClass("active");
     }
      if(data_size == 'l'){
        jQuery("table.custom-table").find("td:nth-child(4)").addClass("active");
     }
      if(data_size == 'xl'){
        jQuery("table.custom-table").find("td:nth-child(5)").addClass("active");
     }
     $(".sizeguide-select-info").each(function() {
         var data_table_size = $(this).attr("data-size");
         if (data_table_size == data_size) {
             $(this).show();
         }
     });
     // trigger on variants
     const thisValue = $(this).data('value');
       $('[type="radio"]').each(function(){
        $(this).closest(".product-form__input").find("input").prop("checked", false);
         const value = $(this).data('data-oruam-value');
        // const value = $(this).data('value');
        if (value == thisValue) {
          $(this).prop("checked", true); // Trigger a click event on the matching element
        }
       });
      /*
       $('.custom-label-value').each(function() {
        const value = $(this).data('value');
        if (value == thisValue) {
          $(this).click(); // Trigger a click event on the matching element
        }
       });
     */
      $('.custom-label-value').each(function() {
      const value = $(this).data('value');
      if (value == thisValue) {
        $(this).click(); // Trigger a click event on the matching element
      }
     });
    });
   $(document).on("click", ".close_popup, .custom__size__guide", function() {
     $(".sizeguide-wrapper").toggleClass("active");
   });
    $('.centimeter_size_guide_table').show();
    $('.inches_size_guide_table').hide();
    $(document).on("click", ".radio-group-label", function() {
     $(".data_unit_type").hide();
     var crntFor = $(this).attr("data-for");

     $(".data_unit_type").each(function() {
         var data_unit_type = $(this).attr("data-unit-type");
         if (data_unit_type == crntFor) {
             $(this).show();
         }
     });
  });
  $(document).on('click','button.addtovart-btn',function(){
    jQuery('section.sizeguide-wrapper').removeClass("active");
    jQuery('.product-form__buttons [type="submit"]').click();
  });
  // onload default clicked on centimeter
  $(document).on('click', 'span.custom__size__guide', function(event) {
    setTimeout(function() {
     $('.radio-group-item.cm_round_button input').click();
    }, 100); // 1000 milliseconds = 1 second
  });
  $('.custom_inches').hide();
  $(document).on('click','.inches_round_button input',function(){
    $('.custom_centimeter').hide();
    $('.custom_inches').show();
  });
  $(document).on('click','.cm_round_button input',function(){
    $('.custom_inches').hide();
    $('.custom_centimeter').show();
  });
 // add class overly into body
  $(document).on('click','.buttonsize',function(){
     $('body').addClass('scroll_overlay');
  });
  $(document).on('click','.popup.sizepop a.close',function(){
     $('body').removeClass('scroll_overlay');
  });